// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerbaseBanner":"to_a bik_b bik_bj","StrollerbaseBanner__hint":"to_b bik_vh","StrollerbaseBanner__link":"to_c"};